module.exports = __webpack_public_path__ + "img/add-graph-icon-17022022.e9309e50.svg";